import { useEffect } from 'react';

export interface ToastMessage {
  id: number;
  text: string;
  type: 'success' | 'error' | 'warning' | 'info';
}

interface ToastProps {
  toasts: ToastMessage[];
  onRemove: (id: number) => void;
}

const iconMap: Record<string, string> = {
  success: 'ri-checkbox-circle-line',
  error: 'ri-close-circle-line',
  warning: 'ri-error-warning-line',
  info: 'ri-information-line',
};

const bgMap: Record<string, string> = {
  success: '#27ae60',
  error: '#e74c3c',
  warning: '#e67e22',
  info: '#2E86C1',
};

export default function Toast({ toasts, onRemove }: ToastProps) {
  return (
    <div className="fixed top-4 right-4 z-[100] flex flex-col gap-2 max-w-sm">
      {toasts.map((toast) => (
        <ToastItem key={toast.id} toast={toast} onRemove={onRemove} />
      ))}
    </div>
  );
}

function ToastItem({ toast, onRemove }: { toast: ToastMessage; onRemove: (id: number) => void }) {
  useEffect(() => {
    const timer = setTimeout(() => {
      onRemove(toast.id);
    }, 5000);
    return () => clearTimeout(timer);
  }, [toast.id, onRemove]);

  return (
    <div
      className="flex items-center gap-3 px-4 py-3 rounded-xl shadow-lg backdrop-blur-sm animate-slide-in text-white text-sm font-medium"
      style={{ backgroundColor: bgMap[toast.type] || bgMap.info }}
    >
      <div className="w-5 h-5 flex items-center justify-center shrink-0">
        <i className={iconMap[toast.type] || iconMap.info}></i>
      </div>
      <span className="flex-1">{toast.text}</span>
      <button
        onClick={() => onRemove(toast.id)}
        className="w-5 h-5 flex items-center justify-center shrink-0 rounded-full hover:bg-white/20 transition-colors cursor-pointer"
      >
        <i className="ri-close-line text-xs"></i>
      </button>
    </div>
  );
}